import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

class InfiniteScroll extends Component {
  constructor(props) {
    super(props);

    this.setRef = this.setRef.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onScroll = _.debounce(this.onScroll, props.debounce);
  }

  componentDidMount() {
    const element = this.getScrollElement();

    element.addEventListener('mousewheel', this.onScroll);
    element.addEventListener('touchmove', this.onScroll);
    element.addEventListener('scroll', this.onScroll);
    element.addEventListener('resize', this.onScroll);
  }

  componentWillUnmount() {
    const element = this.getScrollElement();

    element.removeEventListener('mousewheel', this.onScroll);
    element.removeEventListener('touchmove', this.onScroll);
    element.removeEventListener('scroll', this.onScroll);
    element.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    const { offset, topHandler, bottomHandler } = this.props;
    const topDistance = this.getRemainingDistanceToTop();
    const bottomDistance = this.getRemainingDistanceToBottom();

    const scrolledToTop = offset >= topDistance;
    const scrolledToBottom = offset >= bottomDistance;

    if (scrolledToTop) topHandler();
    if (scrolledToBottom) bottomHandler();
  }

  getRemainingDistanceToTop() {
    const element = this.getScrollElement();
    const remainingTop = element.scrollTop;
    return remainingTop;
  }

  getRemainingDistanceToBottom() {
    const element = this.getScrollElement();
    const { offsetHeight, scrollHeight, scrollTop } = element;
    const remainingBottom = scrollHeight - offsetHeight - scrollTop;

    return remainingBottom;
  }

  getScrollElement() {
    return this.component ? this.component.parentNode : {};
  }

  setRef(node) {
    this.component = node;
  }

  render() {
    const { children } = this.props;
    return <div ref={this.setRef}>{children}</div>;
  }
}

InfiniteScroll.defaultProps = {
  children: null,
  debounce: 0,
  offset: 0,
  topHandler: () => {},
  bottomHandler: () => {},
};

InfiniteScroll.propTypes = {
  children: PropTypes.node,
  debounce: PropTypes.number,
  offset: PropTypes.number,
  topHandler: PropTypes.func,
  bottomHandler: PropTypes.func,
};

export default InfiniteScroll;
